import type profileId from "./id";

const profileEn: typeof profileId = {
	profile: {
		title: "Profile",
		subtitle: "Manage your password and support access",
		tabs: {
			password: "Change Password",
			support: "Support Access",
		},
		password: {
			title: "Change Password",
			old: "Current Password",
			new: "New Password",
			confirm: "Confirm New Password",
			submit: "Save",
			success: "Password changed",
			errors: {
				required: "Required",
				min: "At least 8 characters",
				mismatch: "Passwords do not match",
			},
		},
		support: {
			title: "Support Access",
			description:
				"Let the Cazh support team sign in to your account temporarily to help resolve an issue.",
			label: "Enable support access",
			active_until: "Active until",
			enabled: "Support access enabled",
			disabled: "Support access disabled",
		},
	},
};

export default profileEn;
